import { render, staticRenderFns } from "./TopList.vue?vue&type=template&id=5b36bdf4&scoped=true&"
import script from "./TopList.vue?vue&type=script&lang=js&"
export * from "./TopList.vue?vue&type=script&lang=js&"
import style0 from "./TopList.vue?vue&type=style&index=0&id=5b36bdf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b36bdf4",
  null
  
)

export default component.exports